import type { DateRecurField } from '@uncinc/react-drupal-core/types';

import { PUBLIC_EVENT_STATUS } from '../config/constants';
import formatEventDates from './formatEventDates';

/**
 * @name Unpacked
 *
 * This type expects an array as parameter,
 * and returns the type of its array items.
*/
type Unpacked<T extends any[]> = T extends (infer U)[] ? U : T;

const eventDateInfo = (
  dates: DateRecurField[],
  registrationOpenDate?: string,
  status: string = PUBLIC_EVENT_STATUS,
) => {
  const formattedDates = formatEventDates(dates);

  let firstUpcomingDate = null as Unpacked<DateRecurField['dates']> | null;
  const today = new Date();

  formattedDates.forEach((date) => {
    if (new Date(date.start.date) > today) {
      if (firstUpcomingDate === null) {
        firstUpcomingDate = date;
      } else if (new Date(date.start.date) < new Date(firstUpcomingDate.start.date)) {
        firstUpcomingDate = date;
      }
    }
  });

  // An event is open for registration when registrationOpenDate is not
  // specified, which means it will always be open, or if today is on
  // or passed the registrationOpenDate.
  const isOpenForRegistration = !registrationOpenDate ||
    today.getTime() >= new Date(registrationOpenDate).getTime();

  const isPublic = status === PUBLIC_EVENT_STATUS;

  return {
    firstUpcomingDate,
    dates: formattedDates,
    isOpenForRegistration,
    isPublic,
  };
};

export default eventDateInfo;
